/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CitationTokenReference } from './CitationTokenReference';
export type SecurityCitationCreateRequest = {
  /**
   * The cell's field name, as the grid sends it.
   */
  field_name: string;
  /**
   * A live document of the security's company.
   */
  document_reference: number;
  /**
   * The evidence the citation holds after this call. To add a selection to a citation the cell shows, send its references plus the selection. tokenIds and plainText are accepted for token_ids and plain_text.
   */
  token_references: Array<CitationTokenReference>;
  /**
   * append keeps the field's other citations; replace dismisses its other AI citations when this call creates or adopts a row.
   */
  mode?: SecurityCitationCreateRequest.mode;
};
export namespace SecurityCitationCreateRequest {
  /**
   * append keeps the field's other citations; replace dismisses its other AI citations when this call creates or adopts a row.
   */
  export enum mode {
    APPEND = 'append',
    REPLACE = 'replace',
  }
}

